<template>
  <div class="pt-5">
    <Card>
      <template v-slot:title-panel>
        Datos del cliente
      </template>

      <v-form ref="firstStepForm" :lazy-validation="true">
        <v-row>
          <v-col cols="3" md="6" lg="3">
            <v-textarea
              label="Nombre"
              v-model="solicitudLocal.nombre"
              rows="2"
              auto-grow
              :rules="rulesFor('nombre')"
              outlined
              color="#b11f1f"
              :readonly="isViewMode"
            />
          </v-col>

          <v-col cols="3" md="6" lg="3">
            <v-textarea
              label="Apellido paterno"
              v-model="solicitudLocal.apellidoPaterno"
              rows="2"
              auto-grow
              :rules="rulesFor('apellido_paterno')"
              outlined
              color="#b11f1f"
              :readonly="isViewMode"
            />
          </v-col>

          <v-col cols="3" md="6" lg="3">
            <v-textarea
              label="Apellido materno"
              v-model="solicitudLocal.apellidoMaterno"
              rows="2"
              auto-grow
              :rules="rulesFor('apellido_materno')"
              outlined
              color="#b11f1f"
              :readonly="isViewMode"
            />
          </v-col>

          <v-col cols="3" md="6" lg="3">
            <v-text-field
              label="Fecha de nacimiento"
              v-model="solicitudLocal.fechaNacimiento"
              type="date"
              :rules="rulesFor('fechaNacimiento')"
              outlined
              color="#b11f1f"
              :readonly="isViewMode"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="3" md="6" lg="3">
            <v-textarea
              label="RFC"
              v-model="solicitudLocal.rfc"
              rows="2"
              auto-grow
              :rules="rulesFor('rfc')"
              outlined
              color="#b11f1f"
              :readonly="isViewMode"
            />
          </v-col>

          <v-col cols="3" md="6" lg="3">
            <v-select
              label="Género"
              :items="generos"
              v-model="solicitudLocal.sexo"
              rows="2"
              auto-grow
              :rules="rulesFor('genero')"
              outlined
              color="#b11f1f"
              :readonly="isViewMode"
            />
          </v-col>

          <v-col cols="3" md="6" lg="3">
            <v-select
              label="Estado civil"
              v-model="solicitudLocal.estadoCivil"
              :items="estados_civil"
              :rules="rulesFor('estado_civil')"
              outlined
              color="#b11f1f"
              :readonly="isViewMode"
            />
          </v-col>

          <v-col cols="3" md="6" lg="3">
            <v-textarea
              label="Edad"
              v-model="solicitudLocal.edad"
              rows="2"
              auto-grow
              :rules="rulesFor('edad')"
              outlined
              color="#b11f1f"
              :readonly="isViewMode"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="3" md="6" lg="3">
            <v-textarea
              label="Teléfono"
              v-model="solicitudLocal.celularMovil"
              rows="2"
              auto-grow
              :rules="rulesFor('celularMovil')"
              outlined
              color="#b11f1f"
              :readonly="isViewMode"
            />
          </v-col>

          <v-col cols="3" md="6" lg="3">
            <v-textarea
              label="Correo electrónico"
              v-model="solicitudLocal.correoElectronico"
              rows="2"
              auto-grow
              :rules="rulesFor('correo')"
              outlined
              color="#b11f1f"
              :readonly="isViewMode"
            />
          </v-col>
        </v-row>

        <v-row v-if="!isViewMode || canSave">
          <v-col cols="12" md="12" lg="12" class="text-end">
            <v-btn rounded dark class="common-botton mr-2" @click="goBack">
              Regresar
            </v-btn>

            <v-btn rounded dark class="common-botton" @click="validateStep">
              {{ isEditMode ? "Actualizar" : "Guardar" }}
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </Card>
  </div>
</template>

<script>
import Card from "@/components/commondComponents/Card.vue";
import RfcFacil from "rfc-facil";
import { getClienteById } from "@/services/clienteService";

export default {
  components: { Card },

  props: {
    mode: {
      type: String,
      default: "view", // "create", "edit", "view"
    },
    clientSave: {
      type: Boolean,
      default: false,
    },
    solicitud: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {  
      solicitudLocal: {
        cliente_id: null,
        nombre: null,
        apellidoPaterno: null,
        apellidoMaterno: null,
        fechaNacimiento: null,
        rfc: null,
        sexo: null,
        estadoCivil: null,
        edad: null,
        celularMovil: null,
        correoElectronico: null,
      },

      generos: ["Masculino", "Femenino"],
      estados_civil: ["Soltero(a)", "Casado(a)"],
    };
  },

  computed: {
    isViewMode() {
      return this.mode === "view";
    },
    isEditMode() {
      return this.mode === "edit";
    },
    canSave() {
      return this.clientSave === true;
    },
  },
  watch: {
    solicitud: {
      immediate: true,
      deep: true,
      handler(newVal) {
        this.solicitudLocal = JSON.parse(JSON.stringify(newVal || {}));
        if (this.solicitudLocal.telefono != null) {
          this.solicitudLocal.celularMovil = this.solicitudLocal.telefono;
        }
        if (this.solicitudLocal.celular != null) {
          this.solicitudLocal.celularMovil = this.solicitudLocal.celular;
        }

        if (this.solicitudLocal.cliente_id != null) {
          this.getClientData();
        }
      },
    },

    "solicitudLocal.fechaNacimiento"(newValue) {
      if (newValue) {
        this.solicitudLocal.edad = this.calcularEdad(newValue);
        this.getRfc();
      } else {
        this.solicitudLocal.edad = "";
      }
    },
    "solicitudLocal.nombre"() {
      this.getRfc();
    },
    "solicitudLocal.apellidoPaterno"() {
      this.getRfc();
    },
    "solicitudLocal.apellidoMaterno"() {
      this.getRfc();
    },
  },
  methods: {
    rulesFor(field) {
      if (this.isViewMode) return [];

      const required = [(v) => !!v || "El campo es requerido"];

      if (field === "correo") {
        return [
          ...required,
          (v) => !v || /.+@.+\..+/.test(v) || "Debe ser un correo válido",
        ];
      }

      if (field === "celularMovil") {
        return [
          ...required,
          (v) => !v || /^[0-9\s()+-]{7,15}$/.test(v) || "Teléfono inválido",
        ];
      }
      if (field === "fechaNacimiento") {
        return [
          (v) => !!v || "La fecha es obligatoria",
          (v) => /^\d{4}-\d{2}-\d{2}$/.test(v) || "Formato de fecha inválido",
          (v) => {
            if (typeof v !== "string" || !v.includes("-"))
              return "Formato inválido";
            const [year] = v.split("-");
            const yearNum = parseInt(year, 10);
            const currentYear = new Date().getFullYear();
            return (
              (yearNum >= 1900 && yearNum <= currentYear) || "Año inválido"
            );
          },
        ];
      }

      return required;
    },

    validateStep() {
      if (this.$refs.firstStepForm.validate()) {
        // const action = this.isEditMode ? "edit" : "create";
        this.$emit("onSubmit", { ...this.solicitudLocal, mode: this.mode });
      }
    },
    calcularEdad(fechaNacimiento) {
      const nacimiento = new Date(fechaNacimiento);
      const hoy = new Date();
      let edad = hoy.getFullYear() - nacimiento.getFullYear();
      const mes = hoy.getMonth() - nacimiento.getMonth();

      if (mes < 0 || (mes === 0 && hoy.getDate() < nacimiento.getDate())) {
        edad--;
      }
      return edad;
    },
    getRfc() {
      const {
        nombre,
        apellidoPaterno,
        apellidoMaterno,
        fechaNacimiento,
      } = this.solicitudLocal;

      if (!nombre || !apellidoPaterno || !apellidoMaterno || !fechaNacimiento) {
        return;
      }

      const partesFecha = fechaNacimiento.split("-");
      const [year, month, day] = partesFecha;

      this.solicitudLocal.rfc = RfcFacil.forNaturalPerson({
        name: nombre,
        firstLastName: apellidoPaterno,
        secondLastName: apellidoMaterno,
        day,
        month,
        year,
      });
    },
    goBack() {
      this.solicitudLocal = {};
      this.$emit("onCancel");
    },
    async getClientData() {
      const clientData = await getClienteById(this.solicitudLocal.cliente_id);

      this.solicitudLocal = {
        nombre: clientData.nombre || "",
        apellidoPaterno: clientData.apellidoPaterno || "",
        apellidoMaterno: clientData.apellidoMaterno || "",
        celularMovil: clientData.telefonoMovil || "",
        correoElectronico: clientData.correo || "",
        fechaNacimiento: clientData.fechaNacimiento || "",
        sexo: clientData.genero === "M" ? "Masculino" : "Femenino",
        estadoCivil: clientData.estadoCivil || "",
        rfc: clientData.rfc || "",
      };
    },
  },
};
</script>
